<template>
  <div class="wrap1-content" v-if="wageLength" v-loading.lock="loading">
    <ul>
      <li v-for="item in wageList" :key="item.payroll_scheme_id">
        <div class="pay-info">
          <span class="name">{{ item.name }}</span>
          <el-tag size="mini">{{ item.settlement_type_text }}</el-tag>
          <el-tag size="mini">{{ item.tax_deduction_status_text }}</el-tag>
        </div>
        <div class="item-btn">
          <el-button type="text" @click="goToDetail(item, '2')" v-if="$p('menu.payroll.scheme.edit')">{{
            $t('71')
          }}</el-button>
          <el-button type="text" @click="delPayrollScheme(item)" v-if="$p('menu.payroll.scheme.delete')">{{
            $t('65')
          }}</el-button>
        </div>
      </li>
    </ul>
  </div>
  <div class="not-data" v-else>
    <img src="@/assets/img/icon-not.png" alt="" />
    <span>{{ $t('no_data') }}</span>
  </div>
</template>

<script>
import { getSchemeList, deleteScheme } from 'api/payroll/pay-slip'
export default {
  data() {
    return {
      loading: true,
      wageLength: -1,
      wageList: [] // 方案列表
    }
  },
  computed: {
    listLen() {
      return this.wageList.length
    }
  },
  mounted() {
    this.$router.push({ query: { active: '1' } })
    this.getSchemeList()
  },
  methods: {
    async getSchemeList() {
      // 工资条列表
      this.loading = true
      getSchemeList()
        .then(res => {
          if (res && res.code === 1) {
            this.wageList = res.data
            this.wageLength = res.data.length
          }
        })
        .finally(() => (this.loading = false))
    },
    goToDetail(item, state) {
      // 跳转配置页
      this.$router.push({
        path: '/payroll/edit-pay-slip/' + item.id,
        query: {
          ...this.$route.query,
          payslip_scheme_id: item.id,
          state
        }
      })
    },
    delPayrollScheme(params, index) {
      // 删除工资条
      this.$confirm(this.$t('1087'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
        .then(async () => {
          deleteScheme({ payslip_scheme_id: params.id }).then(res => {
            if (res && res.code === 1) this.getSchemeList()
            this.$message.success(this.$t('806'))
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1-content {
  width: 100%;
  overflow: hidden;
  ul {
    width: 100%;
    overflow-x: auto;
    li {
      min-width: 1000px;
    }
  }
}
</style>
